import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { t } from 'ember-intl';
import { eq, lte } from 'ember-truth-helpers';

interface HotelRankingTooltipsTooltipRankingCalendarSignature {
  Args: {
    tooltipData: unknown;
    type: unknown;
  };
}

export default class HotelRankingTooltipsTooltipRankingCalendar extends Component<HotelRankingTooltipsTooltipRankingCalendarSignature> {
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];

  <template>
    <table>
      <thead>
        <tr>
          <th class="hotel-name">
            {{t "ranking.hotel_header"}}
          </th>
          <th class="ranking-value">
            {{#if (eq @type "reviewScore")}}
              {{t "ranking.review_score"}}
            {{else}}
              {{t "ranking.ranking"}}
            {{/if}}
          </th>
        </tr>
      </thead>
      <tbody>
        {{! @glint-expect-error: Incorrect type }}
        {{#each @tooltipData as |data|}}
          {{#if data.hotel.name}}
            <tr
              class={{if
                (eq data.hotel.id this.hotelAndMarketService.hotel.hotelinfo.id)
                "highlight"
                ""
              }}
            >
              <td class="hotel-name">
                {{#if data.backgroundColor}}
                  <div
                    class="identifier-bullet"
                    style={{data.backgroundColor}}
                  ></div>
                {{/if}}
                {{data.hotel.name}}
              </td>
              <td class="ranking-value truncate">
                {{#if (lte data.ranking 0)}}
                  {{#if data.message}}
                    {{t data.message}}
                  {{else}}
                    {{t "general.missing"}}
                  {{/if}}
                {{else}}
                  {{data.ranking}}
                {{/if}}
              </td>
            </tr>
          {{/if}}
        {{/each}}
      </tbody>
    </table>
  </template>
}
